import { ListItem, ListItemText, useTheme } from "@mui/material";
import React, { useState } from "react";

import { EditFieldButton } from "@/shared/components";
import { UpdateScheduledTriggerRequest } from "@/shared/domain/actions/TriggerRecord";

import { TriggerSchedule } from "./TriggerSchedule";

interface EditableTriggerScheduleProps {
  value: string;
  onChange: (updates: UpdateScheduledTriggerRequest) => void;
  setErrorText: (errorText: string) => void;
}

export const EditableTriggerSchedule: React.FC<
  EditableTriggerScheduleProps
> = ({ value, onChange, setErrorText }) => {
  const theme = useTheme();

  const [showEditableIcon, setShowEditableIcon] = useState(false);
  const [editable, setEditable] = useState(false);
  const [schedule, setSchedule] = useState<string>(value);
  const [scheduleError, setScheduleError] = useState<string | undefined>(
    undefined,
  );

  const updateTrigger = (newSchedule: string): boolean => {
    setErrorText("");

    if (scheduleError) {
      return false;
    }

    onChange({
      schedule: newSchedule.trim(),
    });

    return true;
  };

  const onEditButtonClicked = () => {
    if (editable) {
      if (!updateTrigger(schedule)) {
        return;
      }
    }

    setEditable(!editable);
  };

  return (
    <ListItem
      onMouseOver={() => {
        setShowEditableIcon(true);
      }}
      onMouseLeave={() => {
        setShowEditableIcon(false);
      }}
    >
      <ListItemText
        primaryTypographyProps={{
          component: "span",
        }}
        sx={{
          mt: theme.spacing(0.5),
        }}
        primary={
          <div>
            <span>Schedule (UTC)</span>

            <EditFieldButton
              editable={editable}
              showEditableIcon={showEditableIcon}
              onClick={() => {
                void onEditButtonClicked();
              }}
            />

            <TriggerSchedule
              editable={editable}
              schedule={schedule}
              onScheduleChanged={setSchedule}
              scheduleError={scheduleError}
              onScheduleError={setScheduleError}
            />
          </div>
        }
      />
    </ListItem>
  );
};
